import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Formik } from 'formik';
import { useEffect, useState } from "react";
import { Alert, Autocomplete, Divider, Grid, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { Loading } from "@/components/common/Loading";
import { Props } from "./ModalIpAccept.type";
import { ConfigurationIPService } from "@/service/services/ConfigurationIP.service";
import { userService } from "@/service/services/User.service";
import { ROLE_SUPER_ADMIN } from "@/toolbox/constants/role-type";
import ___PHRASE from "@/service/translate/translateService";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalIpAccept: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, actionSelected, userIp, onListIps, currentJobOffert, clearState } = props;

    const classIPs = [
        {id: '1', name: ___PHRASE('clase') + ' A', rangeStart: '0.0.0.0', rangeEnd: '127.255.255.255'},
        {id: '2', name: ___PHRASE('clase') + ' B', rangeStart: '128.0.0.0', rangeEnd: '191.255.255.255'},
        {id: '3', name: ___PHRASE('clase') + ' C', rangeStart: '192.0.0.0', rangeEnd: '223.255.255.255'},
        {id: '4', name: ___PHRASE('clase') + ' D', rangeStart: '224.0.0.0', rangeEnd: '239.255.255.255'},
        {id: '5', name: ___PHRASE('clase') + ' E', rangeStart: '240.0.0.0', rangeEnd: '255.255.255.255'},
    ]

    const [loading, setLoading] = useState<boolean>(false);

    const [users, setUsers] = useState([]);
    const [userSelected, setUserSelected] = useState<any>('');

    const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });
    
    const ipOfHelp = (typeClass) => {
        const ip = classIPs.find(classIp => classIp.name == typeClass);
        setData({
            ...data,
            rangeStart: ip.rangeStart,
            rangeEnd: ip.rangeEnd,
        })
    }

    const [data, setData] = useState<any>({
        id: userIp ? userIp.id : '',
        rangeStart: userIp ? userIp.rangeStart : '',
        rangeEnd: userIp ? userIp.rangeEnd : '',
        iduser:  userIp ? userIp.iduser : '',
        permission:  userIp ? userIp.permission : '',
    });

    useEffect(() => {
        getUsers();
    }, []);

    useEffect(() => {
        if(userIp && users){
            setCustomUser(userIp.iduser, users);
        }
    },[userIp, users]);

    const filterUSers = (users) => {
        let newArray = [];
        let arrayTemporal = [];
  
        for(let i=0; i<users.length; i++){
           arrayTemporal = newArray.filter(resp => resp["iduser"] == users[i]["iduser"]);
  
           if(arrayTemporal.length > 0){
              newArray[newArray.indexOf(arrayTemporal[0])]["roles"].push(users[i]["role"])
           }else{
              newArray.push(
              {
                 'id' : i+1,
                 'email' : users[i]["email"] , 
                 'employee' : users[i]["employee"] , 
                 'idemployee' : users[i]["idemployee"] , 
                 'idprofile' : users[i]["idprofile"] , 
                 'iduser' : users[i]["iduser"] , 
                 'n_document' : users[i]["n_document"] , 
                 'profile' : users[i]["profile"] , 
                 'user_name' : users[i]["user_name"] , 
                 'roles' : [users[i]["role"]]
              }
              )
           }
        }
  
        return newArray || [];
    }

    const getUsers = async () => {
        setLoading(true);

        const response = await userService.getUserByCompany();

        if (response.data) {
        let newUsers = [];

        const users = response.data;
        const newArray = filterUSers(users)
        
        newArray.length > 0 && newArray.map((item)=> {
            const validate = (item.roles).find(role => role != ROLE_SUPER_ADMIN)
            if(validate) newUsers.push({...item, 'roles': (item.roles).toString()});
        })

        setUsers(newUsers || [])
        setLoading(false);

        } else {
            console.log('error')
        }
        setLoading(false);
    }

    const validateForm = (values) => {
        let errors: any = {};

        let ipv4_regex = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/;

        if(!values.rangeStart ) errors.rangeStart = "ip requerido";
        if(!values.rangeEnd ) errors.rangeEnd = "ip requerido";
        if(values.rangeStart && !(ipv4_regex.test(values.rangeStart))) errors.rangeStart = "ip inválido";
        if(values.rangeEnd && !(ipv4_regex.test(values.rangeEnd))) errors.rangeEnd = "ip inválido";
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        if(!userSelected && !userIp){
            return (
               setSnackBarConfig(prev => ({ ...prev, open: true, 
                  severity:'warning', 
                  message: ___PHRASE('debeSeleccionarUnUsuario') }
               ))
            );
        }

        const formData = {
            id: values.id,
            rangeStart: values.rangeStart,
            rangeEnd: values.rangeEnd,
            iduser: userIp ? userIp.iduser : userSelected.iduser,
            permission : values.permission
        }

        setLoading(true);
        if(userIp && actionSelected=='edit'){
            await ConfigurationIPService.editAccessIP(formData, userIp.id).then((data) => {
                let apimessage = apiResponseTranslate(data?.data?.message)
                if(data?.data?.status == true){
                    setSnackBarConfig(prev => ({ ...prev, open: true, 
                        severity:'success', 
                        message: ___PHRASE('rangoeditadoip')}
                    ))
                    onListIps && onListIps();
                    closeModal && closeModal();
                    clearState && clearState();
                }else{
                    setSnackBarConfig(prev => ({ ...prev, open: true,
                        severity:'error',
                        message: `${apimessage || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}`}
                    ))
                }
            })
        }else{
            await ConfigurationIPService.acceptIP(formData).then((data) => {
                let apimessage = apiResponseTranslate(data?.data?.message)
                if(data?.data?.status == true){
                    setSnackBarConfig(prev => ({ ...prev, open: true,
                        severity:'success',
                        message: ___PHRASE('rangosdeipcreadossatisfactoriamente')}
                    ))
                    onListIps && onListIps();
                    closeModal && closeModal();
                    clearState && clearState();
                }else{
                    setSnackBarConfig(prev => ({ ...prev, open: true,
                        severity:'error', 
                        message: `${apimessage || ___PHRASE("ocurrioAlgunErrorIntentaloMasTarde")}`}
                    ))
                }
            })
        }
        setLoading(false);
    }

    function setCustomUser(idUser, users): any {
        const data = users && users.find(user => user.iduser === idUser);
        const newData = {
            id: data?.id,
            iduser: data?.iduser,
            email: data?.email,
            user_name: data?.user_name,
            role: data?.role,
            n_document: data?.n_document,
        }
        return setUserSelected(newData);
    }

    return(
        <>

        {loading && <Loading/>}

        <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="sm">
            <ModalHeader
                text={(userIp && actionSelected=='edit') ? ___PHRASE('editarRangoIP') : ___PHRASE('agregarRangoIP')}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >

                                    {
                                        !userIp && (
                                            <Grid item xs={12} container  marginBottom='25px'>
                                                <Grid item xs={4}>
                                                <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE('rangoDirecciones')}:</b></Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                <Select
                                                    id="class"
                                                    variant="standard"
                                                    onChange={(event) => {ipOfHelp(event.target.value)}}
                                                    fullWidth
                                                >
                                                    {
                                                        classIPs.length > 0 && classIPs.map((item, key)=> (
                                                            <MenuItem value={item.name}>{item.name}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                </Grid>
                                            </Grid>
                                        )
                                    }

                                    <Grid item xs={12} container  marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE('rangoInicio')}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="rangeStart"
                                            variant="standard"
                                            type="text" 
                                            name="rangeStart"
                                            multiline
                                            maxRows={4}
                                            fullWidth
                                            value={values.rangeStart}
                                            onChange={handleChange}
                                            placeholder={___PHRASE('escribirIP')}
                                            error={errors.rangeStart && touched.rangeStart ? true : false}
                                        />
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={12} container  marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE('rangoFinal')}:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="rangeEnd"
                                            variant="standard"
                                            type="text" 
                                            name="rangeEnd"
                                            multiline
                                            maxRows={4}
                                            fullWidth
                                            value={values.rangeEnd}
                                            onChange={handleChange}
                                            placeholder={___PHRASE('escribirIP')}
                                            error={errors.rangeEnd && touched.rangeEnd ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                    {
                                        !userIp && (
                                            <Grid item xs={12} container alignItems="center" justifyContent="center" >
                                                <Grid item xs={4}>
                                                <Typography variant="subtitle1" className="custom-input"><b>{___PHRASE('usuario')}:</b></Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Autocomplete
                                                        id="disable-portal"
                                                        // disablePortal
                                                        value={userSelected}
                                                        options={users || []}
                                                        getOptionLabel={(option) => option.user_name || ""}
                                                        fullWidth
                                                        renderInput={(params) => <TextField {...params} variant="standard" label={___PHRASE("escribeParaBuscar")} />}
                                                        onChange={(e, newValue) => {  setUserSelected(newValue) }}
                                                    />
                                                </Grid>
                                            </Grid> 
                                        )
                                    }                                  
                                    {/* {
                                        userIp && (
                                            <Grid container item xs={12} alignItems="center" justifyContent="center">
                                                <Grid item xs={4}>
                                                    <Typography variant="body1"><b>Permiso:</b> </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Select
                                                        id="permission"
                                                        name='permission'
                                                        variant="standard"
                                                        value={values.permission}
                                                        onChange={(event) => { 
                                                        setFieldValue("permission", event.target.value);
                                                        }}
                                                        fullWidth
                                                    >
                                                    <MenuItem key={1} value={1}>Aceptado</MenuItem>;
                                                    <MenuItem key={2} value={0}>Denegado</MenuItem>;
                                                        
                                                    </Select>
                                                </Grid>
                                            </Grid> 
                                        )
                                    } */}         
                                </Grid>
                                <Divider style={{margin: '30px 0px 10px 0px'}}/>
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(userIp && actionSelected=='edit') ? ___PHRASE("actualizar") : ___PHRASE("registrar")}
                                    cancelText={___PHRASE("cancelar")} 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}